import { useContext } from "react";

import type { AuthContextValue } from "./context.ts";
import { AuthContext } from "./context.ts";

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
}
